import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding, withHashLocation } from '@angular/router';

import { AuthInterceptor } from '../shared/interceptors/auth.interceptor';
import { CacheInterceptor } from '../shared/interceptors/cache.interceptor';
import { MockApiInterceptor } from '../shared/interceptors/mock-api.interceptor';
import { routes } from './app.routes';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation(), withComponentInputBinding()),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    { provide: LOCALE_ID, useValue: 'es-MX' },
    providePrimeNG({
      translation: {
        emptyMessage: 'No hay datos disponibles',
        emptyFilterMessage: 'No se encontraron resultados',
        selectionMessage: '{0} elementos seleccionados',
        emptySearchMessage: 'No se encontraron resultados',
      },
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MockApiInterceptor,
      multi: true,
    },
    MessageService,
    ConfirmationService,
  ],
};
